import dclog from './dclog';

const clickDcLog = (event)=>{
  let extra = "";
  if(event && event.target && event.target.getAttribute('data-click-dclog')){
    extra = event.target.getAttribute("data-click-dclog");
  } else if(event && event.currentTarget && event.currentTarget.getAttribute('data-click-dclog')){
    extra = event.currentTarget.getAttribute("data-click-dclog");
  }
  dclog({
    systemName: 'open_iot_btn_action',
    bn: 0,
    action:'click',
    extra: extra,
    un: true,
  });
}

const popDcLog = (v)=>{
  dclog({
    systemName: 'open_iot_btn_action',
    bn: 0,
    action:'pop',
    extra: v,
    un: true,
  });
}

const enterDcLog = (v)=>{
  dclog({
    systemName: 'open_iot_btn_action',
    bn: 0,
    action:'enter',
    extra: v,
    un: true,
  });
}


const pageDcLog = (event)=>{
  let from = window.location.pathname;
  let to = "";
  if(event && event.target && event.target.getAttribute('href')){
    to = event.target.getAttribute("href").split('?')[0];
  } else if(event && event.currentTarget && event.currentTarget.getAttribute('href')){
    to = event.currentTarget.getAttribute("href").split('?')[0];
  }
  dclog({
    systemName: 'open_iot_btn_action',
    bn: 0,
    action: 0,
    un: true,
    extra: `${from.replace('.html','')}_${to.replace('.html','')}`,
  });
}
export default {
  pageDcLog,
  clickDcLog,
  popDcLog,
  enterDcLog
}